import { Button } from "./components/button/button";
import { ProgressBar } from "./components/progressBar/progressBar";
import { Base } from "./controls.base";

export const Controls = Object.assign(Base, {
    ProgressBar: ProgressBar,
    Button: Button
});
